import React from "react";
import HistorialAdjudicaciones from "../../../components/ModificarAdjudicaciones/HistorialAdjudicaciones"; //Se importa el componente para los catálogos

export default function HistorialAdjudicacionesPrincipal(props) {
   // console.log("redirect2", props);
    return (
        <HistorialAdjudicaciones
            idArticulo={props.location.state.idArticulo}
            nombreArticulo={props.location.state.nombreArticulo}
            idTipoDocumentacion={props.location.state.idTipoDocumentacion} 
            nombreEmpresa={props.location.state.nombreEmpresa}
            fecha={props.location.state.fecha}
            tipo={props.location.state.tipo}
            montos={props.location.state.montos}
            />
            
    );
}